<template>
  <div class="">
    <section class="avater-section" :class="locale == 'ar' ? 'rtl' : 'ltr'">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="box-avater" style="margin-top: -50px">
              <br /><br /><br />
              <img
                alt="success"
                class="img-error"
                src="/assets/img/checked.svg"
                style="width: 150px"
                loading="lazy"
              />
              <h6 class="sucess-text" style="font-size: 30px">
                <br />
                شكراً لتبرعك
              </h6>
              <p><br /></p>

              <div class="col-md-12">
                <div class="table-responsive">
                  <table
                    class="table table-striped"
                    style="border: 1px solid #ddd"
                  >
                    <tr>
                      <th style="background: #f6f6f9">جهه التبرع</th>
                      <th>{{ row.data[0].proNameOrType }}</th>
                    </tr>
                    <tr>
                      <th style="background: #f6f6f9">رقم الطلب</th>
                      <td>{{ row.invoice_id }}</td>
                    </tr>
                    <tr>
                      <th style="background: #f6f6f9">حالة العملية</th>
                      <td>{{ row.donation_status }}</td>
                    </tr>

                    <tr>
                      <td style="background: #f6f6f9">المبلغ</td>
                      <td style="direction: ltr">
                        {{ row.amount }} {{ row.currency }}
                      </td>
                    </tr>
                    <tr>
                      <td style="background: #f6f6f9">تاريخ الإرسال</td>
                      <td>{{ row.date }}</td>
                    </tr>

                    <tr>
                      <td style="background: #f6f6f9">رقم المرجع</td>
                      <td>{{ row.invoiceKey }}</td>
                    </tr>
                    <tr>
                      <td style="background: #f6f6f9">طريقة الدفع</td>
                      <td>
                        <span>{{
                          getPaymentMethodName(row.payment_method)
                        }}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <br /><br />
              <div class="about-btn">
                <router-link
                  :to="{ name: 'home' }"
                  class="default-btn theme_btn theme_btn_bg"
                >
                  <i class="flaticon-right"></i>
                  الرجوع الي الصفحة الرئيسية
                  <span></span>
                </router-link>
              </div>
              <br /><br />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { trackDonate } from "@/helpers/pixel";
import { getPaymentMethods } from "@/data/paymentMethods";

export default {
  name: "successPayment",
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      locale: "ar",
      pgLoading: true,
      hash: "",
      row: "",
      paymentMethods: [],
    };
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (this.$route.query.hash) {
      this.hash = this.$route.query.hash;
    } else {
      //this.$router.push({ name: 'home' });
    }

    this.fetchData();
    this.fetchPaymentMethods();
  },
  methods: {
    getPaymentMethodName(id) {
      const method = this.paymentMethods.find((m) => m.PaymentMethodId == id);
      return method
        ? this.locale == "ar"
          ? method.PaymentMethodAr
          : method.PaymentMethodEn
        : "";
    },
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/donations/payment",
        method: "GET",
        data: {},
        params: {
          hash: this.hash,
        },
      };
      this.$axios(options)
        .then((res) => {
          const donation = res.data.data || {};
          if (donation.mobile) {
            try {
              localStorage.setItem("donor_mobile", donation.mobile);
            } catch (e) {}
          }

          const invoiceKey = donation.invoice_id || donation.invoiceKey || this.hash;
          const uniqueKey = "payment_" + invoiceKey;

          // trackDonate fires browser pixel + CAPI for Donate event only
          trackDonate(
            {
              value: donation.amount,
              currency: donation.currency,
              content_name:
                donation.data && donation.data[0]
                  ? donation.data[0].proNameOrType
                  : "",
              content_type: "donation",
            },
            uniqueKey,
            null,
            {
              mobile: donation.mobile,
              email: donation.email_address,
              name: donation.name,
            }
          );

          this.row = res.data.data;
          // window.location.reload();
        })
        .catch(() => {
          //this.$router.push({ name: 'home' });
        })
        .finally(() => {});
    },

    async fetchPaymentMethods() {
      this.paymentMethods = await getPaymentMethods();
    },
  },
};
</script>

<style scoped=""></style>
